const ROUND_ORDER = ["Laatste 64", "Laatste 32", "Laatste 16", "Laatste 8", "Laatste 4", "Finale"];

function sortRounds(a, b) {
  const ia = ROUND_ORDER.indexOf(a);
  const ib = ROUND_ORDER.indexOf(b);
  if (ia === -1 && ib === -1) return a.localeCompare(b);
  if (ia === -1) return 1;
  if (ib === -1) return -1;
  return ia - ib;
}

export const Bracket = ({ matches, nameOf }) => {
  const rounds = {};
  matches.forEach((m) => {
    (rounds[m.round_name] = rounds[m.round_name] || []).push(m);
  });
  const roundNames = Object.keys(rounds).sort(sortRounds);

  return (
    <div className="flex flex-row overflow-x-auto gap-10 p-6 bg-white border border-[#E5E5E5]">
      {roundNames.map((rn) => (
        <div key={rn} className="flex flex-col justify-around gap-6 min-w-[240px]">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#525252] text-center">{rn}</div>
          {rounds[rn]
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((m) => {
              const p1win = m.player1_score != null && m.player2_score != null && m.player1_score > m.player2_score;
              const p2win = m.player1_score != null && m.player2_score != null && m.player2_score > m.player1_score;
              return (
                <div key={m.id} data-testid={`bracket-match-${m.id}`} className="border border-[#E5E5E5] bg-white shadow-sm">
                  <Slot name={nameOf(m.player1_id)} score={m.player1_score} win={p1win} />
                  <div className="h-px bg-[#E5E5E5]" />
                  <Slot name={nameOf(m.player2_id)} score={m.player2_score} win={p2win} />
                </div>
              );
            })}
        </div>
      ))}
    </div>
  );
};

const Slot = ({ name, score, win }) => (
  <div className={`flex justify-between items-center px-4 py-2.5 ${win ? "bg-[#D4AF37]/10" : ""}`}>
    <span className={`text-sm truncate ${win ? "font-bold text-[#0A0A0A]" : "text-[#525252]"}`}>{name}</span>
    <span className="font-mono font-bold text-[#0A0A0A] ml-3">{score ?? "–"}</span>
  </div>
);
